import { action } from 'satcheljs';
import type { AssetId, ProjectId } from 'owa-timestream-types';

/**
 * Callback when a drop executes inside the bucket. Consumer layer can handle seeing the drop action and
 * handling depending on which asset was selected, which the bucket has no knowledge of
 */
export const dropAssetIntoBucket = action(
    'dropAssetIntoBucket',
    (projectId: ProjectId, bucketAssetId: AssetId, order: number) => ({
        projectId,
        bucketAssetId,
        order,
    })
);

/**
 * Callback to remove an asset from a bucket without dragging.
 */
export const removeAssetFromBucket = action(
    'removeAssetFromBucket',
    (projectId: ProjectId, assetId: AssetId, parentAssetId: AssetId) => ({
        projectId,
        assetId,
        parentAssetId,
    })
);
